import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AppMedError } from '../../../error/AppMedError';
import { PatientsApi } from '../../../apis/PatientsApi/PatientsApi';

export function useUpdateBirthDateMutation(patientId?: string) {
    if (!patientId)
        throw new Error('useUpdateBirthDateMutation requires a valid patientId');

    const queryClient = useQueryClient();

    return useMutation<boolean, AppMedError, Date, unknown>({
        mutationKey: [QueryKeys.patientProfileSummary, patientId, 'birthDate'],
        mutationFn: async (birthDate: Date) => {
            return await PatientsApi.updateBirthDate(parseInt(patientId, 10), birthDate);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QueryKeys.patientProfileSummary, patientId] });
        },
    });
}
